<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import Select from '$components/Form/Select.svelte';
    import MeltMultiSelect from '$components/Form/MeltMultiSelect.svelte';
    import find from 'lodash/find';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const placeToSecureOptions = [
        `Maison individuelle`,
        `Appartement`,
        `Entreprise`,
        `Magasin`,
        `Entrepôt`,
        `Chantier`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const needsOptions = [
        `Gardiennage site ou bâtiment`,
        `Sécurité événementielle`,
        `Protection rapprochée`,
        `Maître-chien / brigade cynophile`,
        `Sécurité incendie`,
        `Télésurveillance / vidéosurveillance`,
        `Pose de barbelé / clôture électrique`,
        `Géolocalisation / tracking`,
        `Autre (à préciser)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const assistance24hOptions = [`Oui`, `Non`, `À discuter`].map((v) => ({
        label: v,
        value: v,
        key: v,
    }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.gardiennageSecurite.placesToSecure}
        class=""
        let:field
        let:id
        label={`Quels sont les lieux ou biens à sécuriser ?`}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={placeToSecureOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.gardiennageSecurite.needs}
        class=""
        let:field
        let:id
        label={`Quel type de besoin avez-vous ?`}
        helpLabel="Maximum 4 choix"
    >
        <MeltMultiSelect
            {form}
            {field}
            {id}
            options={needsOptions}
            max={4}
            valueToOption={(v) => ({
                value: v,
                label: find(needsOptions, (o) => o.value === v)?.label ?? '',
            })}
        />
    </Row>

    <Row
        {form}
        field={fields.gardiennageSecurite.assistance24h}
        class=""
        let:field
        let:id
        label={`Souhaitez-vous une assistance 24h/24 ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-2 @[300px]:grid-cols-3 gap-x-6 gap-y-1"
            choices={assistance24hOptions}
        />
    </Row>

    <Row {form} field={fields.message} label={'Votre demande'} required let:field>
        <p>
            Précisez toute autre information utile (horaires, nombre d’agents, contraintes
            spécifiques…)
        </p>

        <Textarea
            {form}
            {field}
            placeholder={`Précisez toute autre information utile (horaires, nombre d’agents, contraintes spécifiques…)`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
